import { Guid, Nillable } from '@web/utils';
import { jsonMember, jsonObject } from 'typedjson';
import { AdminBoxQuantityHistoryReasonType } from '../../enums/admin-box-quantity-history-reason-type';
import { AdminBoxQuantityHistoryOrderResponse } from './admin-box-quantity-history-order.response';

@jsonObject
export class AdminBoxQuantityHistoryCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(Number)
  public readonly change!: number;

  @jsonMember(Number)
  public readonly quantityBeforeChange!: number;

  @jsonMember(Number)
  public readonly quantityAfterChange!: number;

  @jsonMember(String)
  public readonly reason!: AdminBoxQuantityHistoryReasonType;

  @jsonMember(AdminBoxQuantityHistoryOrderResponse)
  public readonly order?: Nillable<AdminBoxQuantityHistoryOrderResponse>;

  @jsonMember(String)
  public readonly createdBy?: Nillable<string>;
}
